import { Link } from "react-router-dom";

const Aboutus = () => {
    return (
        <section className="same_space">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div className="about_hedding">
                            <h2>About Us</h2>
                            <p>At Sparks Heating and Air, LLC, we believe everyone deserves a comfortable and affordable home.
                                We have proudly served Colorado residents for years, helping them stay cool in the summer and warm in the winter.
                                No matter the weather, we can create the perfect indoor environment for your comfort.</p><p>

                                As Denver’s ONLY Factory Direct, offering wholesale-priced HVAC Company, we offer a wide range of services and flexible financing options. Our commitment to our clients is unwavering. We strive to provide the best possible value and ensure you’re completely satisfied with our work.
                            </p><p>
                                Stop waiting and start enjoying the comfort you deserve! Choose Sparks Heating and Air, the best HVAC company in Denver, and transform your house into a "true home."</p>
                            <Link to="/get-quote-step" className="same_btn">Get a Quote<img src="images/right-arrow.svg" alt="" /></Link>
                        </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div className="about_img_book">
                            <img src="images/about.png" alt="" className="w-100" />
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}


export default Aboutus;